import type { MouseEvent as ReactMouseEvent } from "react";
import clsx from "clsx";
import { Bell, Loader2 } from "lucide-react";

interface NotificationBellProps {
  count: number;
  isFetching?: boolean;
  label: string;
  isOpen?: boolean;
  onClick: () => void;
}

export const NotificationBell = ({
  count,
  isFetching = false,
  label,
  isOpen = false,
  onClick,
}: NotificationBellProps) => {
  const displayCount = count > 9 ? "9+" : count;
  const handleClick = (event: ReactMouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onClick();
  };

  return (
    <button
      type="button"
      className="relative rounded-lg p-2 text-content-muted transition-colors hover:bg-surface-secondary hover:text-content-primary"
      aria-label={label}
      aria-haspopup="dialog"
      aria-expanded={isOpen}
      onClick={handleClick}
    >
      <Bell className="h-5 w-5" aria-hidden />
      {count > 0 ? (
        <span className="absolute -right-1 -top-1 inline-flex min-h-[1.25rem] min-w-[1.25rem] items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold text-primary-foreground">
          {displayCount}
        </span>
      ) : null}
      {isFetching ? (
        <Loader2
          className={clsx(
            "absolute bottom-[-0.15rem] right-[-0.15rem] h-3 w-3 animate-spin",
            "text-primary",
          )}
          aria-hidden
        />
      ) : null}
    </button>
  );
};

export default NotificationBell;
